const BPM = 118;
const BEATS_PER_BAR = 4;
const LOOP_BARS = 16;
const LOOP_BEATS = BEATS_PER_BAR * LOOP_BARS;
const TICKS_PER_BEAT = 4;
const SECONDS_PER_BEAT = 60 / BPM;
const SCHEDULE_AHEAD_SECONDS = 0.55;
const SCHEDULER_MS = 80;
const LEFT_HAND_VOLUME = 0.1;

type NoteKind = 'lead' | 'bell';

interface NoteEvent {
  tick: number;
  midi: number;
  beats: number;
  velocity: number;
  kind: NoteKind;
}

interface BassEvent {
  tick: number;
  midi: number;
  velocity: number;
}

interface ChordEvent {
  tick: number;
  notes: number[];
}

const lead: NoteEvent[] = [
  n(0, 73, 0.45, 0.055, 'lead'),
  n(3, 76, 0.35, 0.048, 'lead'),
  n(6, 78, 0.45, 0.05, 'lead'),
  n(9, 76, 0.45, 0.045, 'lead'),
  n(12, 71, 0.55, 0.044, 'lead'),
  n(16, 73, 0.35, 0.05, 'lead'),
  n(18, 71, 0.35, 0.042, 'lead'),
  n(20, 69, 0.65, 0.045, 'lead'),
  n(24, 73, 0.45, 0.048, 'lead'),
  n(28, 76, 0.55, 0.045, 'lead'),
  n(32, 76, 0.4, 0.05, 'lead'),
  n(35, 78, 0.35, 0.045, 'lead'),
  n(38, 76, 0.45, 0.045, 'lead'),
  n(42, 73, 0.55, 0.042, 'lead'),
  n(46, 71, 0.6, 0.04, 'lead'),
  n(48, 69, 0.35, 0.046, 'lead'),
  n(50, 71, 0.35, 0.042, 'lead'),
  n(52, 73, 0.55, 0.046, 'lead'),
  n(56, 76, 0.65, 0.042, 'lead'),
  n(60, 73, 0.75, 0.04, 'lead'),
  n(64, 76, 0.35, 0.048, 'lead'),
  n(67, 78, 0.35, 0.045, 'lead'),
  n(70, 81, 0.45, 0.047, 'lead'),
  n(73, 78, 0.45, 0.043, 'lead'),
  n(76, 76, 0.55, 0.04, 'lead'),
  n(80, 73, 0.35, 0.047, 'lead'),
  n(82, 71, 0.35, 0.04, 'lead'),
  n(84, 69, 0.6, 0.043, 'lead'),
  n(88, 71, 0.35, 0.04, 'lead'),
  n(92, 73, 0.55, 0.042, 'lead'),
  n(96, 76, 0.35, 0.046, 'lead'),
  n(99, 78, 0.35, 0.043, 'lead'),
  n(102, 76, 0.45, 0.044, 'lead'),
  n(106, 73, 0.55, 0.04, 'lead'),
  n(110, 71, 0.55, 0.038, 'lead'),
  n(112, 69, 0.45, 0.042, 'lead'),
  n(116, 71, 0.45, 0.038, 'lead'),
  n(120, 73, 0.55, 0.04, 'lead'),
  n(124, 69, 0.8, 0.035, 'lead'),
  n(128, 73, 0.32, 0.052, 'lead'),
  n(130, 76, 0.32, 0.048, 'lead'),
  n(132, 78, 0.32, 0.052, 'lead'),
  n(136, 81, 0.45, 0.05, 'lead'),
  n(140, 78, 0.42, 0.044, 'lead'),
  n(144, 76, 0.32, 0.048, 'lead'),
  n(146, 73, 0.32, 0.043, 'lead'),
  n(148, 71, 0.42, 0.04, 'lead'),
  n(152, 69, 0.32, 0.042, 'lead'),
  n(154, 71, 0.28, 0.04, 'lead'),
  n(156, 73, 0.55, 0.046, 'lead'),
  n(160, 76, 0.32, 0.052, 'lead'),
  n(162, 78, 0.32, 0.048, 'lead'),
  n(164, 81, 0.42, 0.052, 'lead'),
  n(168, 83, 0.45, 0.045, 'lead'),
  n(172, 81, 0.45, 0.042, 'lead'),
  n(176, 78, 0.32, 0.047, 'lead'),
  n(178, 76, 0.32, 0.043, 'lead'),
  n(180, 73, 0.48, 0.042, 'lead'),
  n(184, 76, 0.28, 0.045, 'lead'),
  n(186, 78, 0.28, 0.043, 'lead'),
  n(188, 76, 0.5, 0.04, 'lead'),
  n(192, 73, 0.32, 0.052, 'lead'),
  n(194, 76, 0.32, 0.047, 'lead'),
  n(196, 78, 0.32, 0.05, 'lead'),
  n(200, 81, 0.42, 0.048, 'lead'),
  n(204, 85, 0.36, 0.045, 'lead'),
  n(207, 83, 0.32, 0.041, 'lead'),
  n(210, 81, 0.42, 0.043, 'lead'),
  n(214, 78, 0.5, 0.04, 'lead'),
  n(216, 76, 0.28, 0.047, 'lead'),
  n(218, 78, 0.28, 0.043, 'lead'),
  n(220, 81, 0.48, 0.044, 'lead'),
  n(224, 83, 0.32, 0.046, 'lead'),
  n(226, 81, 0.32, 0.043, 'lead'),
  n(228, 78, 0.42, 0.04, 'lead'),
  n(232, 76, 0.32, 0.043, 'lead'),
  n(234, 73, 0.32, 0.039, 'lead'),
  n(236, 71, 0.42, 0.038, 'lead'),
  n(240, 69, 0.28, 0.04, 'lead'),
  n(242, 71, 0.28, 0.038, 'lead'),
  n(244, 73, 0.32, 0.042, 'lead'),
  n(246, 76, 0.32, 0.039, 'lead'),
  n(248, 78, 0.42, 0.038, 'lead'),
  n(252, 73, 0.68, 0.034, 'lead'),
];

const bells: NoteEvent[] = [
  n(7, 81, 0.25, 0.024, 'bell'),
  n(15, 78, 0.25, 0.02, 'bell'),
  n(31, 76, 0.25, 0.022, 'bell'),
  n(47, 81, 0.25, 0.02, 'bell'),
  n(71, 85, 0.25, 0.02, 'bell'),
  n(95, 81, 0.25, 0.019, 'bell'),
  n(111, 78, 0.25, 0.019, 'bell'),
  n(135, 85, 0.22, 0.024, 'bell'),
  n(143, 88, 0.2, 0.021, 'bell'),
  n(159, 85, 0.22, 0.021, 'bell'),
  n(175, 88, 0.22, 0.02, 'bell'),
  n(191, 85, 0.22, 0.021, 'bell'),
  n(207, 90, 0.2, 0.019, 'bell'),
  n(223, 88, 0.22, 0.019, 'bell'),
  n(239, 85, 0.22, 0.018, 'bell'),
  n(247, 81, 0.2, 0.016, 'bell'),
];

const bass: BassEvent[] = [
  b(0, 45, 0.035),
  b(8, 52, 0.026),
  b(16, 52, 0.03),
  b(24, 47, 0.024),
  b(32, 54, 0.032),
  b(40, 49, 0.024),
  b(48, 50, 0.03),
  b(56, 52, 0.024),
  b(64, 45, 0.033),
  b(72, 52, 0.024),
  b(80, 52, 0.03),
  b(88, 47, 0.023),
  b(96, 54, 0.03),
  b(104, 49, 0.023),
  b(112, 50, 0.028),
  b(120, 52, 0.023),
  b(128, 45, 0.026),
  b(136, 57, 0.018),
  b(144, 52, 0.024),
  b(152, 59, 0.017),
  b(160, 54, 0.025),
  b(168, 61, 0.017),
  b(176, 50, 0.023),
  b(184, 57, 0.016),
  b(192, 45, 0.025),
  b(200, 57, 0.017),
  b(208, 52, 0.023),
  b(216, 59, 0.016),
  b(224, 54, 0.024),
  b(232, 61, 0.016),
  b(240, 50, 0.022),
  b(248, 52, 0.016),
];

const chords: ChordEvent[] = [
  c(0, [61, 64, 69, 73]),
  c(16, [59, 64, 68, 71]),
  c(32, [61, 66, 69, 73]),
  c(48, [57, 62, 66, 71]),
  c(64, [61, 64, 69, 73]),
  c(80, [59, 64, 68, 71]),
  c(96, [61, 66, 69, 73]),
  c(112, [62, 66, 69, 74]),
  c(128, [64, 69, 73, 76]),
  c(144, [64, 68, 71, 76]),
  c(160, [66, 69, 73, 78]),
  c(176, [62, 66, 71, 74]),
  c(192, [64, 69, 73, 76]),
  c(208, [64, 68, 71, 76]),
  c(224, [66, 69, 73, 78]),
  c(240, [62, 66, 69, 74]),
];

const noteEvents = [...lead, ...bells];
const loopTicks = LOOP_BEATS * TICKS_PER_BEAT;

function n(tick: number, midi: number, beats: number, velocity: number, kind: NoteKind): NoteEvent {
  return { tick, midi, beats, velocity, kind };
}

function b(tick: number, midi: number, velocity: number): BassEvent {
  return { tick, midi, velocity };
}

function c(tick: number, notes: number[]): ChordEvent {
  return { tick, notes };
}

function midiToHz(midi: number): number {
  return 440 * Math.pow(2, (midi - 69) / 12);
}

class GameplayMusic {
  private context: AudioContext | null = null;
  private master: GainNode | null = null;
  private intervalId: number | null = null;
  private nextTick = 0;
  private loopStart = 0;
  private playing = false;
  private unlockBound = false;
  private readonly unlockAudio = (): void => {
    this.resume();
  };

  start(): void {
    const context = this.ensureContext();
    if (!this.master) return;

    this.bindUnlock();
    this.resume();

    if (this.playing) return;
    this.playing = true;
    this.nextTick = 0;
    this.loopStart = context.currentTime + 0.08;
    this.master.gain.cancelScheduledValues(context.currentTime);
    this.master.gain.setValueAtTime(0.0001, context.currentTime);
    this.master.gain.exponentialRampToValueAtTime(0.9, context.currentTime + 1.2);
    this.scheduler();
    this.intervalId = window.setInterval(() => this.scheduler(), SCHEDULER_MS);
  }

  stop(): void {
    if (!this.context || !this.master) return;
    const now = this.context.currentTime;
    this.playing = false;
    this.master.gain.cancelScheduledValues(now);
    this.master.gain.setTargetAtTime(0.0001, now, 0.22);

    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.unbindUnlock();
  }

  private ensureContext(): AudioContext {
    if (this.context) return this.context;
    const context = new AudioContext();
    const master = context.createGain();
    const lowpass = context.createBiquadFilter();
    const compressor = context.createDynamicsCompressor();

    master.gain.value = 0.0001;
    lowpass.type = 'lowpass';
    lowpass.frequency.value = 5600;
    lowpass.Q.value = 0.35;
    compressor.threshold.value = -24;
    compressor.knee.value = 18;
    compressor.ratio.value = 3;
    compressor.attack.value = 0.02;
    compressor.release.value = 0.25;

    master.connect(lowpass);
    lowpass.connect(compressor);
    compressor.connect(context.destination);

    this.context = context;
    this.master = master;
    return context;
  }

  private resume(): void {
    const context = this.context;
    if (!context) return;
    void context
      .resume()
      .then(() => {
        if (context.state === 'running') this.unbindUnlock();
      })
      .catch(() => undefined);
  }

  private scheduler(): void {
    if (!this.playing || !this.context) return;
    const tickSeconds = SECONDS_PER_BEAT / TICKS_PER_BEAT;
    const scheduleUntil = this.context.currentTime + SCHEDULE_AHEAD_SECONDS;

    while (this.loopStart + this.nextTick * tickSeconds < scheduleUntil) {
      const tick = this.nextTick % loopTicks;
      const time = this.loopStart + this.nextTick * tickSeconds;
      this.scheduleTick(tick, time);
      this.nextTick += 1;
    }
  }

  private scheduleTick(tick: number, time: number): void {
    for (const chord of chords) {
      if (chord.tick === tick) this.playChord(chord.notes, time, BEATS_PER_BAR * SECONDS_PER_BEAT);
    }
    for (const bassNote of bass) {
      if (bassNote.tick === tick) this.playBass(bassNote.midi, time, bassNote.velocity);
    }
    for (const event of noteEvents) {
      if (event.tick === tick) this.playNote(event, time);
    }
  }

  private playChord(notes: number[], start: number, duration: number): void {
    const chordDuration = Math.min(duration, 1.35);
    notes.forEach((midi, index) => {
      this.playPianoTone(midi, start + index * 0.035, chordDuration, 0.017, 0.42);
    });
  }

  private playBass(midi: number, start: number, velocity: number): void {
    this.playPianoTone(midi + 12, start, 0.55, velocity * LEFT_HAND_VOLUME, 0.2);
  }

  private playNote(event: NoteEvent, start: number): void {
    const duration = event.beats * SECONDS_PER_BEAT;
    const brightness = event.kind === 'bell' ? 0.68 : 0.52;
    this.playPianoTone(event.midi, start, duration, event.velocity, brightness);
  }

  private playPianoTone(
    midi: number,
    start: number,
    duration: number,
    velocity: number,
    brightness: number,
  ): void {
    const context = this.context;
    const master = this.master;
    if (!context || !master) return;

    const gain = context.createGain();
    const filter = context.createBiquadFilter();
    const fundamental = context.createOscillator();
    const overtone = context.createOscillator();
    const shimmer = context.createOscillator();

    const freq = midiToHz(midi);
    const release = Math.max(0.22, Math.min(duration + 0.18, 0.9));
    filter.type = 'lowpass';
    filter.frequency.setValueAtTime(2600 + brightness * 4200, start);
    filter.frequency.exponentialRampToValueAtTime(1300 + brightness * 2400, start + release);
    filter.Q.setValueAtTime(0.25, start);

    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(velocity, start + 0.008);
    gain.gain.exponentialRampToValueAtTime(Math.max(velocity * 0.18, 0.0002), start + 0.075);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + release);

    fundamental.type = 'triangle';
    fundamental.frequency.setValueAtTime(freq, start);
    overtone.type = 'sine';
    overtone.frequency.setValueAtTime(freq * 2, start);
    shimmer.type = 'sine';
    shimmer.frequency.setValueAtTime(freq * 3.01, start);

    const overtoneGain = context.createGain();
    const shimmerGain = context.createGain();
    overtoneGain.gain.setValueAtTime(velocity * (0.11 + brightness * 0.08), start);
    shimmerGain.gain.setValueAtTime(velocity * brightness * 0.045, start);

    fundamental.connect(filter);
    overtone.connect(overtoneGain);
    shimmer.connect(shimmerGain);
    overtoneGain.connect(filter);
    shimmerGain.connect(filter);
    filter.connect(gain);
    gain.connect(master);

    fundamental.start(start);
    overtone.start(start);
    shimmer.start(start);
    fundamental.stop(start + release + 0.03);
    overtone.stop(start + release + 0.03);
    shimmer.stop(start + release + 0.03);
  }

  private bindUnlock(): void {
    if (this.unlockBound) return;
    this.unlockBound = true;
    window.addEventListener('pointerdown', this.unlockAudio, { passive: true });
    window.addEventListener('keydown', this.unlockAudio);
  }

  private unbindUnlock(): void {
    if (!this.unlockBound) return;
    this.unlockBound = false;
    window.removeEventListener('pointerdown', this.unlockAudio);
    window.removeEventListener('keydown', this.unlockAudio);
  }
}

export const gameplayMusic = new GameplayMusic();
